<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">
      Listado de {{ this.mode === "SELLERS" ? "vendedores" : "usuarios" }}
    </h4>
    <button type="button" class="close" (click)="cancel()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <pos-list
      [data]="this.dataSource"
      [filters]="this.tableFilters"
      [config]="this.config"
      [itemsPerPage]="5"
      (dataChange)="
        this.mode === 'SELLERS'
          ? this.getEmployeesData($event)
          : this.getUsersData($event)
      "
      (rowClick)="handleRowClick($event)"
    ></pos-list>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">
      Cancelar
    </button>
  </div>
</div>
